import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const useCartItemsQuery = (
  options: Partial<Omit<UseQueryOptions<any, any, any, any>, 'queryKey' | 'queryFn' | 'select'>> = {}
) => {
  return useQuery({
    queryKey: ['cartItems'],
    queryFn: () => axios.get(jsRoutes.controllers.Cart.view().url),
    select: (data) => data.data,
    ...options,
  });
};
